import * as ngCore from '@angular/core'

import * as directives from '../../../directives'
import { AtnDsTableStore } from '../store'

import * as columnHeaders from './column-headers'
import * as emptyState from './empty-state'
import * as rows from './rows'

const PAGINATION_HEIGHT = 61
const SEARCH_HEIGHT = 50
const CONTAINER_PADDING_HEIGHT = 10

@ngCore.Component({
  imports: [
    emptyState.Component,
    columnHeaders.Component,
    rows.Component,
    directives.measuredElement.Directive,
  ],
  selector: 'table-data',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link AtnDsTableStore} */
  public store = ngCore.inject(AtnDsTableStore)

  /** Reference to table container element*/
  private readonly _tableContainerSg =
    ngCore.viewChild<ngCore.ElementRef<HTMLElement>>('tableContainer')

  /** @see {@link AtnDsTableStore.hoveredRowElSg} */
  public readonly topSg = ngCore.computed(
    (el = this.store.hoveredRowElSg()) => {
      if (!el) {
        return 0
      }
      // TODO: explain the offset
      const offset = 200
      return el.getBoundingClientRect().top - offset
    },
  )

  /** TODO: add documentation */
  public readonly containerHeightSg = ngCore.computed(
    (
      isEmbedded = this.store.isEmbeddedSg(),
      hasSearch = this.store.hasSearchSg(),
      hasPagination = this.store.showPaginationSg(),
    ) => {
      let reservedPixels = 0

      if (!isEmbedded) {
        reservedPixels += CONTAINER_PADDING_HEIGHT
      }

      if (hasSearch) {
        reservedPixels += SEARCH_HEIGHT
      }

      if (hasPagination) {
        reservedPixels += PAGINATION_HEIGHT
      }

      return `calc(100% - ${reservedPixels}px)`
    },
  )

  constructor() {
    // Track actual table width changes using ResizeObserver
    ngCore.effect(() => {
      const tableContainer = this._tableContainerSg()
      if (!tableContainer) {
        return
      }

      const element = tableContainer.nativeElement
      const resizeObserver = new ResizeObserver(() => {
        const tableWidth = element.getBoundingClientRect().width ?? 0
        this.store.patchState({ tableWidth })
      })

      resizeObserver.observe(element)

      // Cleanup
      return () => {
        resizeObserver.disconnect()
      }
    })
  }

  /**
   * Handles the horizontal table scroll event and updates the store with the new offset position from the left edge.
   *
   * @param event - The scroll event triggered by the table container.
   */
  public onTableScrollHandler(event: Event): void {
    const scrollableElement = event.target as HTMLElement
    const horizontalScrollLeftOffsetPosition = scrollableElement.scrollLeft
    this.store.patchState({ horizontalScrollLeftOffsetPosition })
  }
}
